import { Component, OnInit, Input } from '@angular/core';
import { Stream } from 'src/models/stream';
import { PlayerService } from 'src/app/services/player.service';
import { UserService } from 'src/app/services/user.service';
import { FormResponse } from 'src/models/form-response';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from 'src/app/services/account.service';
import { FormResponseError } from 'src/models/form-response-error';
import { forkJoin, combineLatest } from 'rxjs';
import { Router } from '@angular/router';
import { Episode } from 'src/models/episode';

@Component({
  selector: 'app-list-stream-item',
  templateUrl: './list-stream-item.component.html',
  styleUrls: ['./list-stream-item.component.scss']
})
export class ListStreamItemComponent implements OnInit {

  @Input() stream: Stream;
  @Input() smallPlayIcon: boolean;

  public isFavorite = false;

  public isPlaying = false;

  constructor(
    private playerService: PlayerService,
    private userService: UserService,
    private accountService: AccountService, 
    private toastr: ToastrService,
    private router: Router) {
    }

  ngOnInit(): void {
    this.userService.getFavorites().subscribe((streams: Stream[]) => {
      const streamFound = streams.find((fav: Stream) => fav.id === this.stream.id);

      this.isFavorite = streamFound !== undefined;
    });

    combineLatest(this.playerService.currentStream, this.playerService.isPlaying).subscribe(([stream, isPlaying]) => {
      this.isPlaying = this.stream.id === stream.id && isPlaying;
    });
  }

  public onPlayStreamClicked(stream: Stream) {

    if (isNaN(stream.id)) {
      if (stream instanceof Episode) {
        this.router.navigate(['/podcast/' + stream.podcast.id]);
      } else {
        this.router.navigate(['/podcast/' + stream.id]);
      }
    } else {
      this.router.navigate(['/radio/' + stream.title.toLowerCase().replace(/\s/g, '-')]);
      /*if (this.isPlaying) {
        this.playerService.pause();
      } else {
        this.playerService.setCurrentStream(stream);
      }*/

      this.isPlaying = !this.isPlaying;
    }
  }

  public toggleFavorite() {

    if (this.accountService.loggedInUser.getValue() === undefined) {
      this.toastr.error('Du musst eingeloggt sein, um diese Aktion auszuführen.', 'Fehler');
    } else {
      const observable = !this.isFavorite ?
                              this.userService.addToFavorites(this.stream) :
                              this.userService.removeFromFavorites(this.stream);

      const isFavorite = !this.isFavorite;

      observable.subscribe((formResponse: FormResponse) => {

        const favoriteTypeLabel = this.stream.type === 'podcast' ? 'Podcast' : 'Sender';

        if (formResponse.result) {
          if (isFavorite) {
            this.toastr.success('Der ' + favoriteTypeLabel + ' wurde hinzugefügt.');
          } else {
            this.toastr.success('Der ' + favoriteTypeLabel + ' wurde entfernt.');
          }
        } else {
          let errorText = 'Es ist ein Fehler aufgetreten.';

          if (formResponse.errors !== undefined) {
            const errors = formResponse.errors.filter((error: FormResponseError) => {
              return error.field === 'default';
            });

            if (errors.length > 0) {
              errorText = '';

              errors.forEach((error: FormResponseError) => {
                if (errorText.length > 0) errorText += '<br />';

                errorText += error.msg;
              })
            }
          }

          this.toastr.error(errorText, 'Fehler');
        }

      });
    }
  }

}
